import React from "react"

import BaseSvgIcon from "../Base"

export const CelebrationNexus = ({width = 44, height = 44, fill = "black", ...props}) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <g clipPath="url(#clip0_6380_24489)">
      <path
        d="M16.2543 16.7244C15.3006 15.7708 13.9448 15.3801 12.6235 15.6559C11.3022 15.9431 10.2336 16.8738 9.774 18.1377L2.35152 38.1301C1.8115 39.5893 2.15619 41.1864 3.25922 42.2894C4.01756 43.0478 5.00569 43.4499 6.02829 43.4499C6.48788 43.4499 6.95897 43.3695 7.41857 43.1971L27.411 35.7747C28.6749 35.3036 29.6056 34.235 29.8928 32.9252C30.1801 31.6038 29.7779 30.248 28.8242 29.2944L16.2543 16.7244ZM13.0486 19.3556C13.1176 19.1718 13.2554 19.1028 13.3588 19.0798C13.3933 19.0798 13.4278 19.0684 13.4623 19.0684C13.5542 19.0684 13.6576 19.1028 13.761 19.1947L15.3581 20.7918L18.5868 35.2921L14.3585 36.8662L11.2102 24.5375C11.2102 24.5375 11.1758 24.4571 11.1643 24.4226L13.0486 19.3556ZM6.18915 39.911C5.97084 39.9915 5.82147 39.911 5.72955 39.8076C5.63763 39.7157 5.54571 39.5663 5.62614 39.348L9.03864 30.1791L11.0609 38.1071L6.18915 39.9225V39.911ZM26.4573 32.1668C26.4343 32.2702 26.3654 32.4196 26.1816 32.4771L21.9188 34.0627L20 25.4108L26.3539 31.7647C26.4918 31.9026 26.4918 32.0634 26.4688 32.1668H26.4573Z"
        fill={fill}
      />
      <path
        d="M24.9526 20.5862C25.2973 20.9309 25.7454 21.1032 26.1935 21.1032C26.6416 21.1032 27.0897 20.9309 27.4344 20.5862L36.3391 11.6815C37.0285 10.9921 37.0285 9.88906 36.3391 9.19966C35.6497 8.51027 34.5467 8.51027 33.8573 9.19966L24.9526 18.1043C24.2632 18.7937 24.2632 19.8968 24.9526 20.5862Z"
        fill={fill}
      />
      <path
        d="M19.1728 14.601C19.3797 14.6815 19.575 14.7159 19.7818 14.7159C20.4942 14.7159 21.1606 14.2793 21.4249 13.5784L24.8144 4.46694C25.1476 3.55924 24.688 2.54813 23.7803 2.21492C22.8726 1.88171 21.8615 2.34131 21.5283 3.24901L18.1387 12.3605C17.8055 13.2682 18.2651 14.2793 19.1728 14.6125V14.601Z"
        fill={fill}
      />
      <path
        d="M43.3362 21.7588C43.0029 20.8511 41.9918 20.3915 41.0841 20.7247L31.9726 24.1142C31.0649 24.4474 30.6053 25.4585 30.9386 26.3662C31.2028 27.0671 31.8692 27.5037 32.5816 27.5037C32.7884 27.5037 32.9952 27.4693 33.1906 27.3888L42.3021 23.9993C43.2098 23.6661 43.6694 22.655 43.3362 21.7473V21.7588Z"
        fill={fill}
      />
      <path
        d="M37.5572 32.708C36.4311 32.708 35.5234 33.6272 35.5234 34.7417C35.5234 35.8562 36.4311 36.7639 37.5572 36.7639C38.6832 36.7639 39.5794 35.8562 39.5794 34.7417C39.5794 33.6272 38.6717 32.708 37.5572 32.708Z"
        fill={fill}
      />
      <path
        d="M40.5435 16.885C41.658 16.885 42.5657 15.9773 42.5657 14.8513C42.5657 13.7253 41.658 12.8291 40.5435 12.8291C39.429 12.8291 38.5098 13.7368 38.5098 14.8513C38.5098 15.9658 39.4175 16.885 40.5435 16.885Z"
        fill={fill}
      />
      <path
        d="M30.6863 7.04008C31.8123 7.04008 32.72 6.12089 32.72 5.00637C32.72 3.89185 31.8123 2.97266 30.6863 2.97266C29.5603 2.97266 28.6641 3.89185 28.6641 5.00637C28.6641 6.12089 29.5718 7.04008 30.6863 7.04008Z"
        fill={fill}
      />
      <path
        d="M11.2 10.429C12.326 10.429 13.2337 9.50979 13.2337 8.39527C13.2337 7.28075 12.326 6.37305 11.2 6.37305C10.0739 6.37305 9.17773 7.28075 9.17773 8.39527C9.17773 9.50979 10.0854 10.429 11.2 10.429Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_6380_24489">
        <rect width="43.3333" height="43.3333" fill={fill} transform="translate(0.200195 0.200195)" />
      </clipPath>
    </defs>
  </BaseSvgIcon>
)
